module.exports = __webpack_public_path__ + "static/media/toYandex.95bcace5.svg";